var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "217.5 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "var(--icon-color, currentColor)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.363 16.9919C253.225 11.48 255.127 3.321 255.988 0C253.84 2.96915 249.051 4.76196 245.974 5.51264C243.17 6.19622 237.736 6.9536 232.552 9.46056C227.395 11.9549 225.329 16.1905 223.817 19.4295C222.156 22.9876 221.225 28.5941 221.225 28.5941C227.231 21.6003 231.169 20.9331 240.363 16.9919Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.499 22.751C221.639 28.2636 219.736 36.4234 218.874 39.7444C221.023 36.7737 225.812 34.9809 228.89 34.231C231.692 33.5467 237.127 32.79 242.311 30.2823C247.466 27.7888 249.534 23.5539 251.045 20.3141C252.706 16.7561 253.638 11.1487 253.638 11.1487C247.631 18.1433 243.695 18.8113 234.499 22.751Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.2c423f6aac318f7e280f741b85b57b06.svg";
export { ForwardRef as ReactComponent };